import React, { useState, useRef } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const MessageInput = ({ onSendMessage, onFileUpload, disabled = false }) => {
  const [message, setMessage] = useState('');
  const [showEmoji, setShowEmoji] = useState(false);
  const fileInputRef = useRef(null);

  const emojis = ['😊', '👍', '❤️', '😂', '😢', '😮', '😡', '🙏', '✈️', '🏖️', '🏔️', '🎉'];

  const quickResponses = [
    "I need help with my booking",
    "Payment issue",
    "Change my itinerary",
    "Cancel my trip"
  ];

  const handleSend = () => {
    if (message.trim() && !disabled) {
      onSendMessage({
        type: 'text',
        content: message.trim()
      });
      setMessage('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file && onFileUpload) {
      onFileUpload(file);
    }
  };

  const handleEmojiSelect = (emoji) => {
    setMessage(prev => prev + emoji);
    setShowEmoji(false);
  };

  const handleQuickResponse = (response) => {
    onSendMessage({
      type: 'text',
      content: response
    });
  };

  return (
    <div className="border-t border-border bg-card">
      {/* Quick Responses */}
      <div className="p-3 border-b border-border">
        <div className="flex flex-wrap gap-2">
          {quickResponses.map((response, index) => (
            <Button
              key={index}
              variant="outline"
              size="sm"
              onClick={() => handleQuickResponse(response)}
              disabled={disabled}
              className="text-xs"
            >
              {response}
            </Button>
          ))}
        </div>
      </div>

      {/* Emoji Picker */}
      {showEmoji && (
        <div className="p-3 border-b border-border">
          <div className="flex flex-wrap gap-2">
            {emojis.map((emoji, index) => (
              <button
                key={index}
                onClick={() => handleEmojiSelect(emoji)}
                className="text-lg hover:bg-muted rounded p-1 transition-colors"
              >
                {emoji}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Message Input */}
      <div className="p-4">
        <div className="flex items-end space-x-2">
          <div className="flex-1">
            <Input
              type="text"
              placeholder="Type your message..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyPress={handleKeyPress}
              disabled={disabled}
              className="resize-none"
            />
          </div>
          
          <div className="flex items-center space-x-1">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => setShowEmoji(!showEmoji)}
              disabled={disabled}
              className="w-10 h-10"
            >
              <Icon name="Smile" size={20} />
            </Button>
            
            <Button
              variant="ghost"
              size="icon"
              onClick={() => fileInputRef.current?.click()}
              disabled={disabled}
              className="w-10 h-10"
            >
              <Icon name="Paperclip" size={20} />
            </Button>
            
            <Button
              variant="default"
              size="icon"
              onClick={handleSend}
              disabled={disabled || !message.trim()}
              className="w-10 h-10"
            >
              <Icon name="Send" size={20} />
            </Button>
          </div>
        </div>
      </div>

      <input
        ref={fileInputRef}
        type="file"
        onChange={handleFileSelect}
        accept="image/*,.pdf,.doc,.docx"
        className="hidden"
      />
    </div>
  );
};

export default MessageInput;